// src/components/Profile/ProfileLayout.js
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../Header/Header';
import ProfileSidebar from './ProfileSidebar';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Footer from '../../Components/Footer/Footer';

const ProfileLayout = () => {
	const [sidebarOpen, setSidebarOpen] = useState(false);

	return (
		<>
			<Header />
			<ToastContainer position="bottom-right" autoClose={3000} />
			<div className="min-h-screen bg-[#F9F6F1] py-8 px-4 sm:px-6 lg:px-8">
				<div className="max-w-7xl mx-auto">
					<div className="flex items-center justify-between mb-8">
						<h1 className="text-3xl font-bold text-yellow-950">My Account</h1>

						{/* Mobile sidebar toggle button */}
						<button
							className="lg:hidden p-2 rounded-md text-gray-500 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500"
							onClick={() => setSidebarOpen(true)}
						>
							<svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
							</svg>
						</button>
					</div>

					<div className="flex flex-col lg:flex-row gap-8 relative items-start">
						<ProfileSidebar
							isOpen={sidebarOpen}
							onClose={() => setSidebarOpen(false)}
						/>
						<div className="w-full lg:w-3/4">
							<Outlet />
						</div>
					</div>
				</div>
			</div>
			<Footer />

		</>
	);
};

export default ProfileLayout;

